import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "flex flex-col w-full bg-white h-screen" }
const _hoisted_2 = { class: "px-4 py-3 flex items-center justify-between border-b" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "back"
}, null, -1)
const _hoisted_5 = { class: "text-16px text-black-lp-300 font-semibold" }
const _hoisted_6 = { class: "px-4" }
const _hoisted_7 = { class: "px-4" }
const _hoisted_8 = { class: "flex gap-x-10 text-16px border-b border-gray-lp-400 px-4 mt-1" }
const _hoisted_9 = { class: "relative group" }
const _hoisted_10 = {
  class: "absolute right-0 z-50 whitespace-nowrap bg-gray-lp-600 text-white text-12px rounded px-2 py-1 shadow opacity-0 group-hover:opacity-100",
  style: {"top":"100%"}
}
const _hoisted_11 = { class: "flex-1 overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadWithDateRange = _resolveComponent("DownloadWithDateRange")!
  const _component_HeaderFilterBar = _resolveComponent("HeaderFilterBar")!
  const _component_SummaryCourierPickup = _resolveComponent("SummaryCourierPickup")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_4
          ]),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.courierDisplayInfo), 1)
        ]),
        _createVNode(_component_DownloadWithDateRange, {
          buttonText: _ctx.$t('pickupDashboard.downloadDataPickUp'),
          onDownload: _ctx.onDownload
        }, null, 8, ["buttonText", "onDownload"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_HeaderFilterBar, {
          dateRange: _ctx.dateRange,
          "onUpdate:dateRange": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateRange = $event)),
          search: _ctx.search,
          "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = $event)),
          shipmentType: _ctx.shipmentType,
          "onUpdate:shipmentType": _cache[4] || (_cache[4] = ($event: any) => (_ctx.shipmentType = $event)),
          onSearch: _ctx.onFilterSearch,
          onFilter: _ctx.onFilterSearch,
          onApplyDate: _ctx.onFilterSearch,
          onResetDate: _ctx.onFilterSearch,
          showDownloadButton: false
        }, null, 8, ["dateRange", "search", "shipmentType", "onSearch", "onFilter", "onApplyDate", "onResetDate"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_SummaryCourierPickup, {
          crrotw: _ctx.crrotw,
          crrpic: _ctx.crrpic,
          crrdon: _ctx.crrdon,
          isLoading: _ctx.isLoadingSummary
        }, null, 8, ["crrotw", "crrpic", "crrdon", "isLoading"])
      ]),
      _createVNode("div", _hoisted_8, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock("button", {
            key: tab.name,
            "data-testid": `pickup-dashboard-tab-count-${tab.name}`,
            onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
            class: 
          `py-3 ${
            _ctx.isTabActive(tab.name)
              ? 'text-red-lp-100 border-b-2 border-red-lp-100 font-semibold'
              : 'text-gray-500 font-semibold'
          }`
        
          }, [
            _createVNode("span", _hoisted_9, [
              _createTextVNode(_toDisplayString(tab.title) + " ", 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.getTabCount(tab.name)), 1)
            ])
          ], 10, ["data-testid", "onClick"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_router_view, { key: _ctx.tabKey })
      ])
    ]),
    _createVNode(_component_WidgetDownload)
  ], 64))
}